import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter, NavLink, Link } from 'react-router-dom'
import { injectIntl } from 'react-intl'
import { MenuItem, Avatar, Tooltip } from '@material-ui/core'
import cn from 'classnames'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'
import { closeMobileMenu } from 'reducers/layout/reducer'
import * as ROUTE from 'constants/appRouting'
import { DashboardsIcon } from 'helpers/customIcons'
import RoleHelper, { ROLE_FEATURE_MANAGER } from 'helpers/role'
import FilterLicensee from 'components/Dashboard/FilterLicensee'
import { getProfileMobileMenu } from 'helpers/menuProfile'
import { showFeedbackFormModal } from 'reducers/feedback/reducer'
import defaultAvatar from 'assets/img/default-avatar.png'
import { REFERRER_TYPES } from 'routes/App/Apps/MonitorsAndAlerts/logTypes'
import message from './translate'
import 'styles/app/sidebar-menu.scss'

class SidebarContent extends Component {
  menuClickHandlers = {
    leaveFeedback: () => this.props.showFeedbackFormModal(true),
  }

  componentDidUpdate(prevProps) {
    const {
      location: { pathname },
    } = this.props

    if (prevProps.location.pathname !== pathname) {
      this.onCloseAfterClick()
    }
  }

  onCloseAfterClick = () => {
    const { onMenuHide, closeMobileMenu } = this.props

    onMenuHide()
    closeMobileMenu()
  }

  getNavIcon = (icon, name) => {
    const CustomIcon = icon || DashboardsIcon

    return (
      <Tooltip placement="right" title={name}>
        <span>
          {typeof icon === 'string' ? (
            <img alt={name} src={icon} className="sidebar-menu-small-icon" />
          ) : (
            <CustomIcon />
          )}
        </span>
      </Tooltip>
    )
  }

  renderMainApps = () => {
    const { applications } = this.props
    const applicationList = applications.toArray()

    return applicationList.map(
      ({ appUrl, appName, appTitle, showInSideBarMenu, appSmallIconPath }) => {
        if (showInSideBarMenu) {
          return (
            <li key={appUrl}>
              <NavLink
                key={appTitle}
                to={appUrl}
                activeClassName="active"
                className="nav-menu-app-link"
                onClick={() => {
                  localStorage.setItem('referrer', REFERRER_TYPES.SIDEBAR)
                  this.onCloseAfterClick()
                }}>
                {ifWindowWidthLessThan(992) ? (
                  <span className="nav-text">{appName}</span>
                ) : (
                  this.getNavIcon(appSmallIconPath, appName)
                )}
              </NavLink>
            </li>
          )
        }

        return null
      },
    )
  }

  renderMenuItems = (menuItems, withIcons) =>
    menuItems.map(({ path, alt, name, icon }) => {
      const {
        intl: { formatMessage },
      } = this.props
      const menuItemTitle = message[name] && formatMessage(message[name])

      return (
        <MenuItem
          button
          key={alt}
          className={cn('nav-menu-items', {
            'main-item': withIcons,
            active: this.props.location.pathname === path,
          })}
          onClick={this.onCloseAfterClick}>
          <Link
            to={path}
            className="nav-menu-app-link"
            onClick={
              this.menuClickHandlers.hasOwnProperty(name)
                ? this.menuClickHandlers[name]
                : null
            }>
            {withIcons && <i className="nav-menu-icons">{icon}</i>}
            <span>{menuItemTitle}</span>
          </Link>
        </MenuItem>
      )
    })

  render() {
    const {
      roleLevel,
      userData,
      allowedToManageWorkflows,
      allowedToManageFeatureFlags,
      intl: { formatMessage },
    } = this.props
    const { name, pictureUrl, licensee } = userData.toJS()
    const logoAlt = `${licensee.name} logo`
    const licenseeLogo = !licensee.logoUrl ? '' : licensee.logoUrl
    const isSuperAdmin = roleLevel >= RoleHelper.ROLE_SUPERADMIN_LEVEL
    const menuItemsUpperGroup = getProfileMobileMenu(
      roleLevel,
      1,
      allowedToManageWorkflows,
      allowedToManageFeatureFlags,
    )
    const menuItemsMiddleGroup = getProfileMobileMenu(
      roleLevel,
      2,
      allowedToManageWorkflows,
      allowedToManageFeatureFlags,
    )
    const menuItemsBottomGroup = getProfileMobileMenu(
      roleLevel,
      3,
      allowedToManageWorkflows,
      allowedToManageFeatureFlags,
    )

    return ifWindowWidthLessThan(992) ? (
      <div className="nav-wrapper">
        <div className="nav-mobile-header">
          <Avatar
            component="div"
            src={pictureUrl || defaultAvatar}
            alt="name"
            className="rounded-circle header-avatar"
          />
          <div className="nav-header-info">
            <div>
              <strong>{name || formatMessage(message.anonymous)}</strong>
              <span className="licenseename">
                &nbsp; (
                {licensee && !isSuperAdmin
                  ? licensee.name
                  : formatMessage(message.company_name)}
                )
              </span>
            </div>
            {isSuperAdmin ? (
              <MenuItem button className="nav-licensee_list">
                <FilterLicensee />
              </MenuItem>
            ) : (
              <div className="logo-wrap">
                <img src={licenseeLogo} alt={logoAlt} />
              </div>
            )}
          </div>
        </div>
        <ul className="nav-menu-body">
          {this.renderMenuItems(menuItemsUpperGroup, true)}
        </ul>
        <h5 className="nav-menu-topic">{formatMessage(message.apps)}</h5>
        <ul
          className="nav nav-menu-body"
          ref={c => {
            // eslint-disable-next-line react/no-unused-class-component-methods
            this.nav = c
          }}>
          {this.renderMainApps()}
        </ul>
        <h5 className="nav-menu-topic">{formatMessage(message.settings)}</h5>
        <ul className="nav-menu-body divider">
          {this.renderMenuItems(menuItemsMiddleGroup)}
        </ul>
        <ul className="nav-menu-body">
          {this.renderMenuItems(menuItemsBottomGroup, true)}
        </ul>
        <MenuItem
          button
          key="Logout"
          component="div"
          className="nav-menu-items main-item"
          onClick={this.onCloseAfterClick}>
          <Link to={ROUTE.LOGOUT} className="nav-menu-app-link">
            <i className="material-icons">exit_to_app</i>
            <span>{formatMessage(message.logout)}</span>
          </Link>
        </MenuItem>
      </div>
    ) : (
      <ul
        className="nav"
        ref={c => {
          // eslint-disable-next-line react/no-unused-class-component-methods
          this.nav = c
        }}>
        {this.renderMainApps()}
      </ul>
    )
  }
}

export default connect(
  state => ({
    roleLevel: state.getIn(['profile', 'roleLevel']),
    userData: state.getIn(['profile', 'profile']),
    applications: state.getIn(['profile', 'profile', 'applications']),
    allowedToManageWorkflows: state.getIn([
      'profile',
      'profile',
      'grantedManageWorkflows',
    ]),
    allowedToManageFeatureFlags: state
      .getIn(['profile', 'profile', 'roles'])
      .includes(ROLE_FEATURE_MANAGER),
  }),
  {
    closeMobileMenu,
    showFeedbackFormModal,
  },
)(injectIntl(withRouter(SidebarContent)))
